module.exports = __webpack_public_path__ + "static/media/loading-img.99e5a144.png";